var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"menu-logo",attrs:{"id":"logo-lien-header","href":_vm.coolocBaseURL,"title":"Retour à la page d'accueil"}},[_c('img',{attrs:{"src":"/static/images/logos/Cooloc-Logo.svg","alt":"Logo COOLOC"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }